
function Config() {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    return "http://localhost:8000"
  } else {
    return "https://asambe-2020.uc.r.appspot.com"
  }
}

export default Config;